// extracted by mini-css-extract-plugin
export default {"root":"InsightCard_root__b41m1","infoContent":"InsightCard_infoContent__5lnmT","thread":"InsightCard_thread__IQSAl"};